import { REPRODUCE_ERROR_LOG_PARAM } from 'data/error-log-constants';
import { getQueryParam } from 'utils/helpers';

function parseUrl(value: string): URL | null {
  try {
    return new URL(value);
  } catch {
    return null;
  }
}

export function canReproduce(log: { url: string }): boolean {
  const parsed = parseUrl(log.url);
  return parsed !== null && parsed.pathname === '/';
}

export function buildReproduceUrl(
  log: { id: number; url: string },
  origin: string = window.location.origin
): string {
  const parsed = parseUrl(log.url);
  const pathname = parsed?.pathname ?? '/';
  const params = new URLSearchParams(parsed?.search ?? '');
  params.set(REPRODUCE_ERROR_LOG_PARAM, String(log.id));
  return `${origin}${pathname}?${params.toString()}`;
}

export function getReproduceErrorLogId(): number | null {
  const raw = getQueryParam(REPRODUCE_ERROR_LOG_PARAM);
  if (!raw) {
    return null;
  }
  const id = Number(raw);
  return Number.isInteger(id) && id > 0 ? id : null;
}
